import { PageHeader } from "@/shared/components/PageHeader";
import { EquipmentLiveMap } from "../components/EquipmentLiveMap";

export function EquipmentsPage() {
	return (
		<div className="space-y-4">
			<PageHeader title="GPS Xarita — Live Tracking" />
			<EquipmentLiveMap />
		</div>
	);
}
